import z from "zod";

export const rejectBillSchema = z.object({
  reject_reason: z.string().min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
});

export type RejectBillValidationSchema = z.infer<typeof rejectBillSchema>;
